import { useEffect, useState } from 'react';

import { PopoverDateTimeRangePicker } from '../DatePicker';

export interface ActionBarDateTimeRangeFilterProps {
  onChange: (value: [Date, Date] | null) => void;
  value: [Date, Date] | null;
  allowEqualDates?: boolean;
  disabled?: boolean;
  maxDate?: Date;
  minDate?: Date;
  placeholder?: string;
  showSeconds?: boolean;
  showTimezone?: boolean;
}

export default function ActionBarDateTimeRangeFilter(props: ActionBarDateTimeRangeFilterProps) {
  const {
    onChange,
    value,
    maxDate,
    minDate,
    disabled = false,
    placeholder,
    showSeconds = true,
    showTimezone = false,
    allowEqualDates,
  } = props;

  const [externalValueStart, externalValueEnd] = value ?? [null, null];

  const [internalValue, setInternalValue] = useState<[Date | null, Date | null]>([
    value?.[0] ?? null,
    value?.[1] ?? null,
  ]);

  const handleChange = ([start, end]: [Date | null, Date | null]) => {
    setInternalValue([start, end]);
    if (start && end) {
      onChange([start, end]);
    }
  };

  useEffect(() => {
    setInternalValue([externalValueStart ?? null, externalValueEnd ?? null]);
  }, [externalValueStart, externalValueEnd]);

  return (
    <PopoverDateTimeRangePicker
      startDate={internalValue[0]}
      endDate={internalValue[1]}
      onChange={handleChange}
      minDate={minDate}
      maxDate={maxDate}
      disabled={disabled}
      showSeconds={showSeconds}
      showTimezone={showTimezone}
      allowEqualDates={allowEqualDates}
      inputProps={{ size: 'md', placeholder }}
      clampDateOutOfRange
    />
  );
}
